import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-login"
  }, [_vm._m(0), _c('main', {
    staticClass: "pdv-login__panel"
  }, [_c('div', {
    class: ['pdv-login__conn-badge', _vm.online ? 'pdv-login__conn-badge--online' : 'pdv-login__conn-badge--offline'],
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('span', {
    staticClass: "pdv-login__conn-dot"
  }), _vm._v(" " + _vm._s(_vm.online ? "Online" : "Offline") + " ")]), _c('div', {
    staticClass: "pdv-login__card"
  }, [_c('img', {
    staticClass: "pdv-login__card-logo",
    attrs: {
      "src": "media/brand/logo.png",
      "alt": "PDV Desktop"
    }
  }), _c('h2', {
    staticClass: "pdv-login__card-title"
  }, [_vm._v("PDV Desktop")]), _c('p', {
    staticClass: "pdv-login__card-sub"
  }, [_vm._v("Acesse para operar o terminal de venda")]), !_vm.online && !_vm.temCacheOffline ? _c('div', {
    staticClass: "pdv-login__alert pdv-login__alert--warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _vm._v(" Sem conexão. Conecte-se à internet para fazer o primeiro acesso. ")]) : _vm._e(), !_vm.online && _vm.temCacheOffline ? _c('div', {
    staticClass: "pdv-login__alert pdv-login__alert--info",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v(" Você está offline. Informe usuário e senha do último acesso neste terminal. ")]) : _vm._e(), _vm.erroLogin ? _c('div', {
    staticClass: "pdv-login__alert pdv-login__alert--error",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle"
  }), _vm._v(" " + _vm._s(_vm.erroLogin) + " ")]) : _vm._e(), _c('form', {
    attrs: {
      "novalidate": "",
      "autocomplete": "on"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "pdv-login__field"
  }, [_c('label', {
    staticClass: "pdv-login__label",
    attrs: {
      "for": "login-email"
    }
  }, [_vm._v(" E-mail / Usuário ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.email,
      expression: "form.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "pdv-login__input",
    class: {
      'pdv-login__input--error': _vm.erros.email
    },
    attrs: {
      "id": "login-email",
      "type": "email",
      "placeholder": "seu@email.com",
      "autocomplete": "username",
      "disabled": _vm.carregando || !_vm.online && !_vm.temCacheOffline
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "email", $event.target.value.trim());
      }, function ($event) {
        _vm.erros.email = '';
      }],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.erros.email ? _c('span', {
    staticClass: "pdv-login__field-error"
  }, [_vm._v(" " + _vm._s(_vm.erros.email) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "pdv-login__field"
  }, [_c('label', {
    staticClass: "pdv-login__label",
    attrs: {
      "for": "login-senha"
    }
  }, [_vm._v("Senha")]), _c('div', {
    staticClass: "pdv-login__input-wrap"
  }, [(_vm.mostrarSenha ? 'text' : 'password') === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.senha,
      expression: "form.senha"
    }],
    staticClass: "pdv-login__input pdv-login__input--has-icon",
    class: {
      'pdv-login__input--error': _vm.erros.senha
    },
    attrs: {
      "id": "login-senha",
      "placeholder": "••••••••",
      "autocomplete": "current-password",
      "disabled": _vm.carregando || !_vm.online && !_vm.temCacheOffline,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.senha) ? _vm._i(_vm.form.senha, null) > -1 : _vm.form.senha
    },
    on: {
      "input": function input($event) {
        _vm.erros.senha = '';
      },
      "change": function change($event) {
        var $$a = _vm.form.senha,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "senha", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "senha", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "senha", $$c);
        }
      }
    }
  }) : (_vm.mostrarSenha ? 'text' : 'password') === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.senha,
      expression: "form.senha"
    }],
    staticClass: "pdv-login__input pdv-login__input--has-icon",
    class: {
      'pdv-login__input--error': _vm.erros.senha
    },
    attrs: {
      "id": "login-senha",
      "placeholder": "••••••••",
      "autocomplete": "current-password",
      "disabled": _vm.carregando || !_vm.online && !_vm.temCacheOffline,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.form.senha, null)
    },
    on: {
      "input": function input($event) {
        _vm.erros.senha = '';
      },
      "change": function change($event) {
        return _vm.$set(_vm.form, "senha", null);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.senha,
      expression: "form.senha"
    }],
    staticClass: "pdv-login__input pdv-login__input--has-icon",
    class: {
      'pdv-login__input--error': _vm.erros.senha
    },
    attrs: {
      "id": "login-senha",
      "placeholder": "••••••••",
      "autocomplete": "current-password",
      "disabled": _vm.carregando || !_vm.online && !_vm.temCacheOffline,
      "type": _vm.mostrarSenha ? 'text' : 'password'
    },
    domProps: {
      "value": _vm.form.senha
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "senha", $event.target.value);
      }, function ($event) {
        _vm.erros.senha = '';
      }]
    }
  }), _c('button', {
    staticClass: "pdv-login__toggle-senha",
    attrs: {
      "type": "button",
      "tabindex": "-1",
      "disabled": _vm.carregando,
      "title": _vm.mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'
    },
    on: {
      "click": function click($event) {
        _vm.mostrarSenha = !_vm.mostrarSenha;
      }
    }
  }, [_c('i', {
    class: _vm.mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'
  })])]), _vm.erros.senha ? _c('span', {
    staticClass: "pdv-login__field-error"
  }, [_vm._v(" " + _vm._s(_vm.erros.senha) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "pdv-login__remember"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.lembrarSenha,
      expression: "lembrarSenha"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.carregando || !_vm.online && !_vm.temCacheOffline
    },
    domProps: {
      "checked": Array.isArray(_vm.lembrarSenha) ? _vm._i(_vm.lembrarSenha, null) > -1 : _vm.lembrarSenha
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.lembrarSenha,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.lembrarSenha = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.lembrarSenha = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.lembrarSenha = $$c;
        }
      }
    }
  }), _c('span', [_vm._v("Lembrar-me")])]), _c('button', {
    staticClass: "pdv-login__btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.carregando || !_vm.online && !_vm.temCacheOffline
    }
  }, [_vm.carregando ? _c('span', {
    staticClass: "pdv-login__btn-spinner"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e(), !_vm.online && _vm.temCacheOffline && !_vm.carregando ? _c('span', [_vm._v(" Continuar Offline ")]) : !_vm.carregando ? _c('span', [_vm._v("Entrar")]) : _c('span', [_vm._v("Entrando...")])])])]), _c('p', {
    staticClass: "pdv-login__version"
  }, [_vm._v(_vm._s(_vm.brandName))])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('aside', {
    staticClass: "pdv-login__branding",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pdv-login__branding-content"
  }, [_c('img', {
    staticClass: "pdv-login__brand-logo",
    attrs: {
      "src": "media/brand/logo.png",
      "alt": "PDV Desktop"
    }
  }), _c('h1', {
    staticClass: "pdv-login__brand-title"
  }, [_vm._v("PDV Desktop")]), _c('p', {
    staticClass: "pdv-login__brand-sub"
  }, [_vm._v(" Ponto de venda integrado e pronto para operar mesmo offline ")]), _c('ul', {
    staticClass: "pdv-login__features"
  }, [_c('li', [_c('i', {
    staticClass: "fas fa-wifi-slash"
  }), _vm._v(" Funciona sem internet")]), _c('li', [_c('i', {
    staticClass: "fas fa-file-invoice"
  }), _vm._v(" Emissão de NFC-e")]), _c('li', [_c('i', {
    staticClass: "fas fa-sync-alt"
  }), _vm._v(" Sincronização automática")]), _c('li', [_c('i', {
    staticClass: "fas fa-cash-register"
  }), _vm._v(" Controle de caixa")])])])]);
}];
export { render, staticRenderFns };